import React from 'react';
import styled, { withTheme } from 'styled-components';
import helpers from 'helpers';
import { withBreakpoints } from 'react-breakpoints';
import { AbstractChart } from 'containers/charts/AbstractChart';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import { getPointWidth } from 'helpers/labs/charts';

const ChartCallout = styled.div`
    width: 100%;
    text-align: center;
    margin-bottom: 15px;
    padding: 15px;
    @media (max-width: 768px) {
        font-size: 13px;
        line-height: 25px;
    }

    b {
        font-weight: bold;
    }
`;

const Badge = styled.span`
    font-size: 1.2em; 
    font-weight: bold;
    padding: 5px;
    border-radius: 10px;
    color: #007DC6;

    @media (max-width: 768px) {
        font-size: 13px;
    }
`;

const CrossChannelLift = (props) => {
    const {
        hasData,
        liftPercentage,
        leftHandConversionRate,
        rightHandConversionRate,
        currentBreakpoint,
        animation = true
    } = props;
    const categories = ['Single Channel Households', 'Multi-Channel Households'];
    const hasLift = liftPercentage > 0;

    const series = [
        {
            name: 'Multi-Channel Households',
            data: [
                null,
                rightHandConversionRate - leftHandConversionRate,
            ],
            color: '#007DC6',
            tooltip: {
                pointFormatter() {
                    return `Conversion Rate: ${rightHandConversionRate.toFixed(2)}%<br/>
                        Lift in Conversion Rate: ${liftPercentage}%`;
                }
            }
        },
        {
            name: 'Single Channel Households',
            data: [leftHandConversionRate, leftHandConversionRate],
            color: '#ccc',
            tooltip: {
                pointFormatter() {
                    return `Conversion Rate: ${leftHandConversionRate.toFixed(2)}%`;
                }
            }
        },
    ];

    const BlockWrapper = styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px;
        margin: 10px;
        flex-direction: column;
    `;


    const noMultiChannelDataBlock = <BlockWrapper>
        <h3><b>We couldn't detect any multi-channel data</b></h3>
    </BlockWrapper>;

    const NoLiftBlock = <BlockWrapper>
        <h3><b>Insufficient data to visualize lift</b></h3>
        <p>We could not visualize lift based on the data provided.</p>
    </BlockWrapper>;

    return (
        <ContentTile
            padding={helpers.contentPadding('chart')}
        >
            <ContentHeader type={'chart'} hideCSVExport={true}>
                {props.title}
            </ContentHeader>
            {(!hasData) && noMultiChannelDataBlock}
            {(!hasLift && hasData) && NoLiftBlock}
            {hasLift &&
                <React.Fragment>
                    <ChartCallout>
                        In households exposed to multiple channels,
                        the data shows a<Badge>{`${liftPercentage}%`}</Badge>lift in conversion rate.
                    </ChartCallout>
                    <AbstractChart
                        exportName={props.exportName}
                        config={{
                            chart: {
                                type: 'column',
                            },
                            tooltip: { enabled: false },
                            title: {
                                text: null,
                            },
                            legend: {
                                enabled: false,
                            },
                            xAxis: {
                                categories,
                                labels: {
                                    style: {
                                        color: 'gray',
                                        fontSize: '14px'
                                    },
                                }
                            },
                            yAxis: {
                                gridLineDashStyle: 'dash',
                                title: {
                                    text: 'Conversion Rate %',
                                },
                                stackLabels: {
                                    enabled: true,
                                    style: {
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        color: 'gray',
                                    },
                                    formatter() {
                                        return `${this.total.toPrecision(3)}%`;
                                    },
                                },
                            },
                            exporting: {
                                enabled: false,
                            },
                            plotOptions: {
                                column: {
                                    stacking: 'normal',
                                    depth: 150,
                                    dataLabels: {

                                        enabled: true,
                                    },
                                },
                                series: {
                                    name: 'Single Channel',
                                    stacking: 'normal',
                                    animation,
                                    pointWidth: getPointWidth(currentBreakpoint),
                                    enableMouseTracking: false,
                                    dataLabels: {
                                        enabled: true,
                                        style: {
                                            fontWeight: 'bold',
                                            color: '#fff',
                                            textOutline: 0,
                                            fontSize: '14px',
                                        },
                                        format: null,
                                        formatter() {
                                            if (this.series.index > 0) {
                                                return null;
                                            }
                                            return '⬆ Lift';
                                        },
                                        align: 'center'
                                    },
                                },
                            },
                            series,
                            credits: {
                                enabled: false,
                            },
                        }}
                    />
                </React.Fragment>
            }
        </ContentTile>
    );
};

export default withTheme(withBreakpoints(CrossChannelLift));



// WEBPACK FOOTER //
// ./src/components/molecules/charts/labs/CrossChannelLift.js